import React from 'react'

import classes from './AlertBubble.module.css'

const alertBubble = props =>(<span className={classes.AlertBubble}></span>)

export default alertBubble